var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"local-loading-wrapper",style:({
    zIndex: _vm.zIndex,
    width: _vm.containerWidth,
    height: _vm.containerHeight,
  })},[_c('div',{staticClass:"local-overlay",class:_vm.overlayClass},[_c('div',{staticClass:"local-loading"},[_c('van-loading',{attrs:{"size":_vm.size,"color":_vm.color,"type":_vm.type,"vertical":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }